import { defineMessage } from 'react-intl';

export const addButtonMessage = defineMessage({
  id: 'Button-label-add',
  defaultMessage: 'Add',
});

export const backButtonMessage = defineMessage({
  id: 'Button-label-back',
  defaultMessage: 'Go back',
});

export const cancelButtonMessage = defineMessage({
  id: 'Button-label-cancel',
  defaultMessage: 'Cancel',
});

export const closeButtonMessage = defineMessage({
  id: 'Button-label-close',
  defaultMessage: 'Close',
});

export const confirmButtonMessage = defineMessage({
  id: 'Button-label-confirm',
  defaultMessage: 'Confirm',
});

export const createButtonMessage = defineMessage({
  id: 'Button-label-create',
  defaultMessage: 'Create',
});

export const editButtonMessage = defineMessage({
  id: 'Button-label-edit',
  defaultMessage: 'Edit',
});

export const nextButtonMessage = defineMessage({
  id: 'Button-label-next',
  defaultMessage: 'Next',
});

export const deleteButtonMessage = defineMessage({
  id: 'Button-label-delete',
  defaultMessage: 'Delete',
});

export const saveButtonMessage = defineMessage({
  id: 'Button-label-save',
  defaultMessage: 'Save',
});

export const updateButtonMessage = defineMessage({
  id: 'Button-label-update',
  defaultMessage: 'Update',
});
